import InboxPage from "containers/admin/inbox/inbox";
import { Breadcrumbs } from "ui/breadcrumbs";
import { FillHeightPage } from "ui/data-grid";
import PageContent from "components/partials/page-content/page-content";

import { useCurrentClient } from "hooks/api/use-clients";

import { getClientPaths } from "utilities/app-routes";

const RecentCreativesPage = () => {
  const currentClient = useCurrentClient();
  const paths = getClientPaths({ clientId: currentClient?.id });

  return (
    <PageContent fixedContent>
      <FillHeightPage>
        <Breadcrumbs
          breadcrumbs={[
            { label: currentClient?.name, href: paths.clientCampaignsPath },
            { label: "Recent creatives", active: true },
          ]}
        />
        <InboxPage lockedClientId={currentClient?.id} />
      </FillHeightPage>
    </PageContent>
  );
};

export default RecentCreativesPage;
